import React, { useState, useRef, useEffect } from 'react'
import axios from 'axios';
import {baseUrl } from "../../../comman/config";
import Select from 'react-select';
import { useNavigate, Link } from 'react-router-dom';
import Loader from '../../Loader';
import { menuAboveTable, withMenuOnTop } from "../../../comman/selectMenu";

export default function Form({detail}) {
   
    const [formData, setFormData] = useState({
        menuitem_id:'',
        menuitem_category : '',
        method: '',
        rm_to_fg_ratio:'',
        // rm_to_fg_ratio_ltrs:'',
        // rm_to_fg_ratio_nos: '',
        fg_consumption_per_person:'',
        // fg_consumption_per_person_ltrs: '',
        // fg_consumption_per_person_nos: '',
        rm_to_bowl_ratio :'',
        // rm_to_bowl_ratio_ltrs :'',
        // rm_to_bowl_ratio_nos :'',
        one_bowl_qty: '',
        avg_density:'',
        // one_bowl_qty_ltrs:'',
        // one_bowl_qty_nos:'',
        raw_mat_per_100_person: '',
        ras_raw_mat_per_100_person:'',
        avg_consumption_per_bowl:'',
        raw_atta_to_finished_atta_multiplier:0,
        conversion_target:'',
    });
    const [validationErrors, setValidationErrors] = useState({
        // menuitem_id : false,
        // menuitem_category : false,
        // method: false,
        // rm_to_fg_ratio:false,
        // rm_to_fg_ratio_ltrs: false,
        // rm_to_fg_ratio_nos:false,
        // fg_consumption_per_person:false,
        // fg_consumption_per_person_ltrs:false,
        // fg_consumption_per_person_nos:false,
        // rm_to_bowl_ratio :false,
        // rm_to_bowl_ratio_ltrs : false,
        // rm_to_bowl_ratio_nos : false,
        // one_bowl_qty: false,
        // one_bowl_qty_ltrs:false,
        // one_bowl_qty_nos:false,
        // raw_mat_per_100_person: false,
        // ras_raw_mat_per_100_person: false,
        // avg_consumption_per_bowl:false,
        // raw_atta_to_finished_atta_multiplier:false

    });
    const [menuitemList, setMenuitemList] = useState([]);
    const [menuitemCategory, setMenuitemCategory] = useState([]);
    // Resolved from the loaded list by name, the way the Rotli rule is keyed elsewhere, rather
    // than by a hardcoded id. formData.menuitem_category follows the item picked above.
    const ROTLI_CATEGORY_NAME = 'રોટલી';
    const isRotliCategory = menuitemCategory.some(
        (c) => c.id == formData.menuitem_category && c.name === ROTLI_CATEGORY_NAME
    );
    const [methodList, setMethodList] = useState([]);
    const [popupOpen , setPopupOpen] = useState(false);
    const [loading, setLoading] = useState(false)
    const formRef = useRef(null);
    
    
    const navigate = useNavigate();
    useEffect(() => {
        getMenuitemList();
        getMenuitemCategory();
        getMethodList();
    }, []);

    useEffect(() => {
        if(detail && methodList){
            setLoading(true)
            const menuitemId = detail[0].menu_item_id;
            const menuItem = menuitemList.find(item => item.id === menuitemId);
            const menuItemObject = menuItem ? { value: menuItem.id, label: `${menuItem.item_name} (${menuItem.eng_name})`, eng_name: menuItem.eng_name, category : menuItem.category }: { value: '', label: '', eng_name : '', category :'' };

            const methodId = detail[0].method;
            const methodItem = methodList.find(item => item.name == methodId);

            const methodObject = methodItem ? { value: methodItem.id, label: methodItem.name }: { value: '', label: '' };
            console.log(methodId);
            setFormData({
                menuitem_id: menuItemObject || '',
                menuitem_category: detail[0].menu_category_id || '',
                method: methodObject || '',
                rm_to_fg_ratio: detail[0].rm_to_fg_ratio || '',
                // rm_to_fg_ratio_ltrs: detail[0].rm_to_fg_ratio_ltrs ||'',
                // rm_to_fg_ratio_nos : detail[0].rm_to_fg_ratio_nos || '',
                fg_consumption_per_person: detail[0].fg_consumption_per_person || '',
                // fg_consumption_per_person_ltrs: detail[0].fg_consumption_per_person_ltrs || '',
                // fg_consumption_per_person_nos: detail[0].fg_consumption_per_person_nos || '',
                rm_to_bowl_ratio : detail[0].rm_to_bowl_ratio || '',
                // rm_to_bowl_ratio_ltrs : detail[0].rm_to_bowl_ratio_ltrs || '',
                // rm_to_bowl_ratio_nos : detail[0].rm_to_bowl_ratio_nos || '',
                one_bowl_qty:  detail[0].one_bowl_qty || '',
                avg_density: detail[0].avg_density || '',
                // one_bowl_qty_ltrs: detail[0].one_bowl_qty_ltrs || '',
                // one_bowl_qty_nos: detail[0].one_bowl_qty_nos || '',
                raw_mat_per_100_person: detail[0].raw_mat_per_100_person || '',
                ras_raw_mat_per_100_person: detail[0].ras_raw_mat_per_100_person || '',
                avg_consumption_per_bowl: detail[0].avg_consumption_per_bowl || '',
                raw_atta_to_finished_atta_multiplier: detail[0].raw_atta_to_finished_atta_multiplier || '',
                conversion_target:'',
            });
            setLoading(false)
        }
        // console.log(detail[0]);
    }, [detail, methodList, menuitemList]);

    const getMenuitemList = async () => {
        const response = await axios.get(`${baseUrl}/item/list`);
        const list = response.data.data.filter((item => item.status == 1));
        setMenuitemList(list);
    }

    const getMenuitemCategory = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=item_category_master&condition=status=1`);
        setMenuitemCategory(response.data.data);
    }
    
    const getMethodList = async () => {
        const response = await axios.get(`${baseUrl}/comman/list?table=method_master`);
        if(!detail){
            // setMethodList(response.data.data.filter((item) => item.id != 2));
            setMethodList(response.data.data);
        }else{
            setMethodList(response.data.data);
        }
        
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log(formData);
        // let newValidationErrors = {
        //     menuitem_id: formData.menuitem_id === '',
        //     menuitem_category : formData.menuitem_category === '',
        //     method: formData.method === '',
        //     rm_to_fg_ratio : formData.rm_to_fg_ratio === '',
        //     // rm_to_fg_ratio_ltrs: formData.rm_to_fg_ratio_ltrs === '',
        //     // rm_to_fg_ratio_nos : formData.rm_to_fg_ratio_nos  === '',
        //     fg_consumption_per_person:formData.fg_consumption_per_person === '',
        //     // fg_consumption_per_person_ltrs:formData.fg_consumption_per_person_ltrs === '',
        //     // fg_consumption_per_person_nos:formData.fg_consumption_per_person_nos === '',
        //     rm_to_bowl_ratio :formData.rm_to_bowl_ratio === '',
        //     // rm_to_bowl_ratio_ltrs : formData.rm_to_bowl_ratio_ltrs === '',
        //     // rm_to_bowl_ratio_nos : formData.rm_to_bowl_ratio_nos === '',
        //     one_bowl_qty: formData.one_bowl_qty === '',
        //     // one_bowl_qty_ltrs:formData.one_bowl_qty_ltrs === '',
        //     // one_bowl_qty_nos:formData.one_bowl_qty_nos === '',
        //     raw_mat_per_100_person: formData.raw_mat_per_100_person === '',
        //     ras_raw_mat_per_100_person: formData.ras_raw_mat_per_100_person === '',
        //     avg_consumption_per_bowl:formData.avg_consumption_per_bowl === '',
        //     // raw_atta_to_finished_atta_multiplier:formData.raw_atta_to_finished_atta_multiplier === ''
        // };
        // // if(meth)
        // setValidationErrors(newValidationErrors);
        // const hasErrors = Object.values(newValidationErrors).some((error) => error);
        // if (hasErrors) {
            
        //     // Find the first invalid input element
        //     const firstInvalidInput = formRef.current.querySelector('.invalid');
        //     if (firstInvalidInput) {
        //       // Scroll to the first invalid input element
        //       firstInvalidInput.scrollIntoView({ behavior: 'smooth', block: 'center' });
        //     }
        // }else {
            let url;
            try {
                setPopupOpen(true);                        
                if(detail){
                    url = `consumption_master/edit/${detail[0].id}`;
                }else{
                    url = "consumption_master/add";
                }
                const response = await axios.post(`${baseUrl}/${url}`,{
                    formData: formData,
                });
                setPopupOpen(false);
                if(response.data.status == true){
                    navigate("/consumption_master/list");
               }else{
                setValidationErrors({error : response.data.msg});
               }
                
            } catch (error) {

                setPopupOpen(false);
                console.log(error);
                
            }
        // }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        
            setFormData((prevData) => {
                const updatedData = {
                    ...prevData,
                    [name]: value,
                };
                if (name === 'rm_to_fg_ratio' || name === 'one_bowl_qty') {
                    const rm_to_fg_ratio = updatedData.rm_to_fg_ratio || 0;
                    const one_bowl_qty = updatedData.one_bowl_qty; // Avoid division by zero
                    updatedData.rm_to_bowl_ratio = one_bowl_qty > 0 ? (rm_to_fg_ratio / one_bowl_qty).toFixed(2) : 0;
                }
                if (name === 'fg_consumption_per_person' || name === 'one_bowl_qty') {
                    const fg_consumption_per_person = updatedData.fg_consumption_per_person || 0;
                    const one_bowl_qty = updatedData.one_bowl_qty; // Avoid division by zero
                    updatedData.avg_consumption_per_bowl = fg_consumption_per_person > 0 ? (one_bowl_qty / fg_consumption_per_person).toFixed(2) : 0;
                }
                if (name === 'fg_consumption_per_person' || name === 'rm_to_fg_ratio') {
                    const fg_consumption_per_person = updatedData.fg_consumption_per_person || 0;
                    const rm_to_fg_ratio = updatedData.rm_to_fg_ratio; // Avoid division by zero
                    updatedData.raw_mat_per_100_person = fg_consumption_per_person > 0 ? ((fg_consumption_per_person / rm_to_fg_ratio) * 100).toFixed(2) : 0;
                }
                return updatedData;
            });
      
        setValidationErrors((prevErrors) => ({
          ...prevErrors,
          [name]: false
        }));
    };

    const handleSelectChange = (data, option) => {
        if(option.name == 'menuitem_id'){
            console.log(data);
            setFormData((prevData) => ({
                ...prevData,
                menuitem_id : data,
                menuitem_category: data.category.id
            }));
        }else{
            setFormData((prevData) => ({
                ...prevData,
                [option.name] : data,
               
            }));
        }
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [option.name]: false
        }));
    }

    useEffect(() => {
        if(formData.method){
            console.log(formData.method);
        }
    }, [formData.method]);
    const customStyles = {
        control: (provided) => ({
            ...provided,
            minWidth: '180px',  
            maxWidth: '100%',  
             
        }),
        menu: (provided) => ({
            ...provided,
            minWidth: '180px',  
            
            maxWidth: '100%',
        }),
        placeholder: (provided) => ({
            ...provided,
            fontSize: "0.80rem",
        }),
    };

    // Saving one method's figures can also write the sibling row, since the two are the same
    // measurement in different units. Which sibling is reachable is decided for you, so the screen
    // asks one question and not two: convert, or don't.
    //
    //     Kgs, Rotli item   -> Nos    a rotli is counted
    //     Kgs, anything else-> Ltrs   everything else is poured
    //     Ltrs or Nos       -> Kgs    the only direction back
    //
    // Kgs used to offer Ltrs AND Nos together, which asked the person entering a recipe to decide
    // something the category already answers -- and let a Rotli row sit on Ltrs, because a default
    // is only applied when the choice it would replace is no longer offered and Ltrs always was.
    //
    // A radio, not a checkbox: "convert" and "don't" are alternatives, and the old checkbox could
    // not express the choice at all on a Nos record.
    const METHOD_LABELS = { 1: 'Kgs', 2: 'Ltrs', 3: 'Nos', 4: 'Readymade - Kgs', 5: 'Readymade - Ltrs', 6: 'Readymade - Nos' };
    const readymade = [4, 5, 6].includes(Number(formData.method?.value));
    const dontConvert = { value: 'none', label: "Don't Convert" };
    const conversionOptions = (() => {
        const method = Number(formData.method?.value);
        if (method === 1 || method === 4) {
            return [
                isRotliCategory
                    ? { value: 'nos', label: `Convert to ${METHOD_LABELS[readymade ? 6 : 3]}` }
                    : { value: 'ltrs', label: `Convert to ${METHOD_LABELS[readymade ? 5 : 2]}` },
                dontConvert,
            ];
        }
        if ([2, 5, 3, 6].includes(method)) {
            return [
                { value: 'kgs', label: `Convert to ${METHOD_LABELS[readymade ? 4 : 1]}` },
                dontConvert,
            ];
        }
        return [];
    })();

    const setConversionTarget = (value) => {
        setFormData((prevData) => ({ ...prevData, conversion_target: value }));
    };

    // Convert is the default, whichever direction it is in: the entry is normally wanted in both
    // units, and the person who does not want the sibling row says so by picking Don't Convert.
    //
    // Re-applied only when the current choice is no longer on offer, so Don't Convert survives the
    // next keystroke that touches the method or the item. Keyed on the offered values rather than
    // on how many there are: both branches offer two now, and a count cannot tell Convert to Nos
    // from Convert to Ltrs when the item changes category under it.
    const offeredValues = conversionOptions.map((o) => o.value).join(',');
    useEffect(() => {
        if (conversionOptions.length === 0) return;
        const stillOffered = conversionOptions.some((o) => o.value === formData.conversion_target);
        if (stillOffered) return;
        // The conversion, never Don't Convert -- it is the first option in every branch above.
        setConversionTarget(conversionOptions[0].value);
    }, [offeredValues]);   // eslint-disable-line react-hooks/exhaustive-deps


    useEffect(()=>{
        console.log(formData)
    },[formData])
  return (
 
 <form ref={formRef}>
    {loading && <Loader/>}
                <div className="space-y-12">
                {validationErrors.error && <div className="text-red-500">Please check consumption master allready exist for this menu item.</div>}
                    <div>
                    <div className="mt-10 space-y-8 lg:space-y-0 lg:flex lg:gap-x-5 lg:flex-wrap">
    <div className="sm:col-span-2">
        <label htmlFor="menuitem_eng" className="block text-sm font-medium leading-6 text-gray-900">
            Menuitem Name (Eng)
        </label>
        <div className="mt-2">
            <Select
                {...menuAboveTable}
                classNamePrefix="select"
                value={formData.menuitem_id}
                name="menuitem_id"
                onChange={(selectedOption, name) => {
                    handleSelectChange(selectedOption, name);
                }}
                styles={withMenuOnTop(customStyles)}
                options={menuitemList.map(item => ({
                    value: item.id,
                    label: `${item.item_name} (${item.eng_name})`,
                    eng_name: item.eng_name,
                    category: item.category
                }))}
                isDisabled={detail}
                filterOption={(option, inputValue) => {
                    return option.data.label.toLowerCase().includes(inputValue.toLowerCase()) ||
                        option.data.eng_name.toLowerCase().includes(inputValue.toLowerCase());
                }}
            />   
        </div>
        {validationErrors.menuitem_id && <div className="text-red-500">Please enter an English name.</div>}
    </div>
    <div className="sm:col-span-2">
        <label htmlFor="menuitem_category" className="block text-sm font-medium leading-6 text-gray-900">
            Menuitem Category
        </label>
        <div className="mt-2">
            <select     
                id="menuitem_category"
                name="menuitem_category"
                disabled
                value={formData.menuitem_category}
                className={`block rounded-md w-full lg:w-52 border ${validationErrors.menuitem_category ? 'border-red-500' : 'border-gray-300'} py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6`}>
                <option value="">Select a Category</option>
                {menuitemCategory.map((item) => (
                    <option value={item.id} key={item.id}>{item.name}</option>
                ))}
            </select>
        </div>
    </div>
</div>
                        
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="method" className="block text-sm font-medium leading-6 text-gray-900">Method</label>
                                <div className="mt-2">
                                <Select
                                        {...menuAboveTable}
                                        classNamePrefix="select"
                                        value={formData.method}
                                        name="method"
                                        styles={withMenuOnTop({
                                            placeholder: (provided) => ({
                                              ...provided,
                                              fontSize: "0.80rem",
                                            }),
                                         
                                          })}
                                          placeholder="Select method"
                                        onChange={(selectedOption, name) => {
                                            handleSelectChange(selectedOption, name);
                                        }}
                                        options={methodList.map(item => ({
                                            value: item.id,
                                            label: item.name
                                        }))}
                                        isDisabled={detail}
                                        filterOption={(option, inputValue) => {
                                            return option.data.label.toLowerCase().includes(inputValue.toLowerCase());
                                        }}
                                    />   
                                </div>
                                {validationErrors.method && <div className="text-red-500">Please select a method.</div>}
                            </div>
                            {conversionOptions.length > 0 && <div className="sm:col-span-2 flex flex-col justify-end mb-2">
                                <span className="block text-sm font-medium leading-6 text-gray-900">Also save as</span>
                                <div className="flex flex-wrap gap-x-4 gap-y-1 mt-1">
                                    {conversionOptions.map((option) => (
                                        <label key={option.value} className="flex items-center gap-x-2 text-sm text-gray-900">
                                            <input
                                              type="radio"
                                              name="conversion_target"
                                              value={option.value}
                                              checked={formData.conversion_target === option.value}
                                              onChange={() => setConversionTarget(option.value)}
                                            />
                                            <span>{option.label}</span>
                                        </label>
                                    ))}
                                </div>
                            </div>}
                        </div>
                        
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="rm_to_fg_ratio" className="block text-sm font-medium leading-6 text-gray-900">RM to FG Ratio ({formData.method.label})</label>
                                <div className="mt-2">
                                <input
                                    id="rm_to_fg_ratio"
                                    name="rm_to_fg_ratio"
                                    type="number" 
                                    step="0.01"
                                    placeholder='RM to FG Ratio'
                                    value={formData.rm_to_fg_ratio}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.rm_to_fg_ratio && <div className="text-red-500">Please enter a rm_to_fg_ratio.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="rm_to_bowl_ratio" className="block text-sm font-medium leading-6 text-gray-900">RM to Bowl Ratio ({formData.method.label})</label>
                                <div className="mt-2">
                                <input
                                    id="rm_to_bowl_ratio"
                                    name="rm_to_bowl_ratio"
                                    type="number" 
                                    step="0.01"
                                    placeholder='RM to Bowl Ratio'
                                    value={formData.rm_to_bowl_ratio}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.rm_to_bowl_ratio && <div className="text-red-500">Please enter a rm_to_bowl_ratio.</div>}
                            </div>

                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="fg_consumption_per_person" className="block text-sm font-medium leading-6 text-gray-900">FG per Person ({formData.method.label})</label>
                                <div className="mt-2">
                                <input
                                    id="fg_consumption_per_person"
                                    name="fg_consumption_per_person"
                                    type="number" 
                                    step="0.01"
                                    placeholder='FG per Person'
                                    value={formData.fg_consumption_per_person}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.fg_consumption_per_person && <div className="text-red-500">Please enter a fg_consumption_per_person.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="avg_consumption_per_bowl " className="block text-sm font-medium leading-6 text-gray-900">Persons per Bowl</label>
                                <div className="mt-2">
                                <input
                                    id="avg_consumption_per_bowl"
                                    name="avg_consumption_per_bowl"
                                    type="number" 
                                    step="0.01"
                                    placeholder='Persons per Bowl'
                                    value={formData.avg_consumption_per_bowl}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.avg_consumption_per_bowl && <div className="text-red-500">Please enter a avg_consumption_per_bowl.</div>}
                            </div>
                        </div>
                        
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="one_bowl_qty" className="block text-sm font-medium leading-6 text-gray-900">One Bowl QTY ({formData.method.label})</label>
                                <div className="mt-2">
                                <input
                                    id="one_bowl_qty"
                                    name="one_bowl_qty"
                                    type="number" 
                                    step="0.01"
                                    placeholder='One Bowl QTY'
                                    value={formData.one_bowl_qty}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.one_bowl_qty && <div className="text-red-500">Please enter a one_bowl_qty.</div>}
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="raw_mat_per_100_person" className="block text-sm font-medium leading-6 text-gray-900">RAS</label>
                                <div className="mt-2">
                                <input
                                    id="raw_mat_per_100_person"
                                    name="raw_mat_per_100_person"
                                    type="number" 
                                    step="0.01"
                                    placeholder='RAS'
                                    value={formData.raw_mat_per_100_person}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.raw_mat_per_100_person && <div className="text-red-500">Please enter a raw_mat_per_100_person.</div>}
                            </div>
                        </div>
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                {/* On a Rotli row this field is not a density -- it holds the weight of
                                    one piece in kgs, which is what turns Kgs into a count. Same rename
                                    Meal Master applies to the same figure. */}
                                <label htmlFor="avg_density" className="block text-sm font-medium leading-6 text-gray-900">{isRotliCategory ? 'Density or 1 Piece (Kgs)' : 'Density'}</label>
                                <div className="mt-2">
                                <input
                                    id="avg_density"
                                    name="avg_density"
                                    type="number" 
                                    step="0.01"
                                    placeholder={isRotliCategory ? 'Density or 1 Piece (Kgs)' : 'Density'}
                                    value={formData.avg_density}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                            </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label htmlFor="ras_raw_mat_per_100_person" className="block text-sm font-medium leading-6 text-gray-900">STD RAS</label>
                                <div className="mt-2">
                                <input
                                    id="ras_raw_mat_per_100_person"
                                    name="ras_raw_mat_per_100_person"
                                    type="number" 
                                    step="0.01"
                                    placeholder='STD RAS'
                                    value={formData.ras_raw_mat_per_100_person}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.ras_raw_mat_per_100_person && <div className="text-red-500">Please enter a ras_raw_mat_per_100_person.</div>}
                            </div>
                        </div>
                       
                        <div className="mt-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-6 gap-x-5 gap-y-8">
                            <div className="sm:col-span-2">
                                <label htmlFor="raw_atta_to_finished_atta_multiplier" className="block text-sm font-medium leading-6 text-gray-900">RM to FG Atta Multiplier</label>
                                <div className="mt-2">
                                <input
                                    id="raw_atta_to_finished_atta_multiplier"
                                    name="raw_atta_to_finished_atta_multiplier"
                                    type="number" 
                                    step="0.01"
                                    placeholder='RM to FG Atta Multiplier'
                                    value={formData.raw_atta_to_finished_atta_multiplier}
                                    onChange={handleInputChange}
                                    onWheel={(e) => e.target.blur()}
                                    onKeyDown={(e) => {if (e.key === 'ArrowUp' || e.key === 'ArrowDown') { e.preventDefault(); }}}
                                    className="block w-full rounded-md border border-gray-300 py-1.5 px-1.5 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 sm:text-sm sm:leading-6"
                                />
                                </div>
                                {validationErrors.raw_atta_to_finished_atta_multiplier && <div className="text-red-500">Please enter a raw_atta_to_finished_atta_multiplier.</div>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="mt-6 flex items-center justify-end gap-x-6">
                    <Link to="/consumption_master/list">
                        <button type="button" className="text-sm font-semibold leading-6 text-gray-900">Cancel</button>
                    </Link>
                    <button
                    onClick={handleSubmit}
                      type="submit"
                      className="rounded-md bg-blue-500 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
                    >
                      Save
                    </button>
                </div>
            </form>
            )
        }